import Konva from 'konva';
import React, { useMemo } from 'react';
import { Text, Group, Rect } from 'react-konva';
import { DateNumber } from 'types/global';
import { monthName } from 'utils/humanize';
import { addDays } from 'utils/time';
import { GraphStyle } from '../types';
import { xFromTimeStyled } from '../utils';


function Timeline({
	start,
	days = 13,
	style,
	...props
}: TimelineProps) {

	const arrDays = useMemo(() =>
		Array.from(iterateDays(start, days)),
		[start, days]
	)

	const xFromTime = xFromTimeStyled(style, start)
	let mountName = ""
	let textMountWidth = 0
	const textYearY = (style.timeline.mount.size - style.timeline.year.size) - 1

	return <Group  {...props} listening={false}>

		{arrDays.map((dayTime, index) => {

			const x = xFromTime(dayTime)
			const dayDate = new Date(dayTime)
			dayDate.setHours(0, 0, 0, 0); //dayDate.setUTCHours(0, 0, 0, 0);
			const dayOfWeek = dayDate.getDay()
			const numDay = dayDate.getDate()
			if (numDay == 1) {
				mountName = monthName(dayDate.getMonth())
				textMountWidth = mountName.length * style.timeline.mount.size * 0.6 + 10
			}

			return (<Group key={index} listening={false}>

				{/* BACKGROUND */}
				{index % 2 == 0 && (<Rect
					listening={false}
					x={x}
					y={style.space.y}
					width={style.space.x}
					height={style.space.y}
					fill={style.timeline.bg.color}
				/>)}

				{/* MOUNT */}
				{numDay == 1 && (<>
					<Text
						listening={false}
						text={mountName}
						fontSize={style.timeline.mount.size} fontStyle="bold"
						fill={style.timeline.mount.color}
						x={x} y={0}
						height={style.space.y}
					/>
					<Text
						listening={false}
						text={dayDate.getFullYear().toString()}
						fontSize={style.timeline.year.size}
						fill={style.timeline.year.color}
						x={x + textMountWidth} y={textYearY}
						height={style.space.y}
					/>
				</>)}

				{/* DAY */}
				<Text listening={false}
					align="center" verticalAlign="middle"
					text={numDay.toString()} fontSize={style.timeline.day.size}
					x={x} y={style.space.y}
					width={style.space.x}
					height={style.space.y}
					fill={style.timeline.day.color}
				/>

				{/* HOLIDAY */}
				{dayOfWeek == 0 && (<Rect
					listening={false}
					strokeWidth={1}
					x={x - (style.space.x)}
					y={style.space.y}
					width={(style.space.x * 2) - 1}
					height={style.space.y}
					stroke={style.timeline.day.weekend}
				/>)}

			</Group>)
		})}
	</Group>
}

export default Timeline

Timeline.CalcHeight = ({ style }) => (style.space.y * 2) + 5


function* iterateDays(start: number, numDays: number) {
	for (let index = 0; index < numDays; index++) {
		yield addDays(start, index)
	}
}

type TimelineProps = {
	x: number,
	y: number,
	start: DateNumber,
	days: number,
	style: GraphStyle,
} & Konva.NodeConfig